import React from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { Layout as AntLayout, Menu } from 'antd';
import { DashboardOutlined, UserOutlined, TeamOutlined, LogoutOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { useAppDispatch } from '../store/hooks';
import { logout } from '../store/slices/authSlice';
import './Layout.scss';

const { Header, Sider, Content } = AntLayout;

const Layout: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const selectedKey =
    location.pathname.startsWith('/customers')
      ? 'customers'
      : location.pathname.startsWith('/ccg')
        ? 'ccg'
        : location.pathname.startsWith('/security')
          ? 'security'
          : 'dashboard';

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <AntLayout className="layout">
      <Sider width={250} className="layout-sider">
        <div className="logo">
          <h2>AminID Portal</h2>
        </div>
        <Menu theme="dark" mode="inline" selectedKeys={[selectedKey]}>
          <Menu.Item key="dashboard" icon={<DashboardOutlined />}>
            <Link to="/dashboard">Dashboard</Link>
          </Menu.Item>
          <Menu.Item key="customers" icon={<UserOutlined />}>
            <Link to="/customers">Customers</Link>
          </Menu.Item>
          <Menu.Item key="ccg" icon={<TeamOutlined />}>
            <Link to="/ccg">CCG Groups</Link>
          </Menu.Item>
          <Menu.Item key="security" icon={<SafetyCertificateOutlined />}>
            <Link to="/security">Security</Link>
          </Menu.Item>
          <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
            Logout
          </Menu.Item>
        </Menu>
      </Sider>
      <AntLayout>
        <Header className="layout-header">
          <h1>Customer Identity Management</h1>
        </Header>
        <Content className="layout-content">
          <Outlet />
        </Content>
      </AntLayout>
    </AntLayout>
  );
};

export default Layout;
